import React from "react";

import classes from "./NavigationOptions.module.scss";
import Notification from "../Notification/Notification";
import UserProfileOption from "./UserProfileOption/UserProfileOption";
import GlobalSearch from "../GlobalSearch/GlobalSearch";
import FeedbackModal from "../FeedbackModal/FeedbackModal";

const navigationOptions = (props) => {
  return (
    <div
      className={[
        classes["nav-options"],
        "d-flex",
        "justify-content-end",
        "align-items-center",
        "flex-grow-1",
      ].join(" ")}
    >
      <GlobalSearch />
      <FeedbackModal />
      <Notification />
      <UserProfileOption />
    </div>
  );
};

export default navigationOptions;
